import React, { useState } from 'react';
import { BookOpenIcon, Type } from 'lucide-react';
import MessageBubble from '../components/MessageBubble';
import ChatInput from '../components/ChatInput';
const Chat = () => {
  const [isListening, setIsListening] = useState(false);
  const [fontSize, setFontSize] = useState<'normal' | 'large' | 'x-large'>('normal');
  const [messages, setMessages] = useState([{
    text: "Hello Maria, I'm here to help. Would you like to tell me about your day?",
    isUser: false,
    timestamp: '10:30 AM'
  }]);
  // Only show last 4 messages
  const recentMessages = messages.slice(-4);
  const getSuggestions = () => {
    const lastMessage = messages[messages.length - 1];
    if (!lastMessage.isUser) {
      if (lastMessage.text.includes('about your day')) {
        return ['I had a lovely morning', "I'm feeling tired", 'Tell me about your day'];
      }
      if (lastMessage.text.includes('feeling tired')) {
        return ["I didn't sleep well", 'Some music would help', 'Just want to rest'];
      }
    }
    return ['Help me remember', 'Family photos', 'Suggest activity'];
  };
  const handleSendMessage = (text: string) => {
    const newUserMessage = {
      text,
      isUser: true,
      timestamp: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setMessages([...messages, newUserMessage]);
    // Simulate AI response
    setTimeout(() => {
      let response = 'I understand. Would you like to tell me more?';
      if (text.toLowerCase().includes('tired')) {
        response = "I hear that you're feeling tired. Would you like to:\n1. Rest\n2. Listen to music\n3. Talk about it?";
      } else if (text.toLowerCase().includes('help')) {
        response = "I'm here to help. What would you like?\n• Daily activities\n• Family photos\n• Reminders";
      }
      const aiMessage = {
        text: response,
        isUser: false,
        timestamp: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })
      };
      setMessages(prevMessages => [...prevMessages, aiMessage]);
    }, 1000);
  };
  return <div className="h-[calc(100vh-130px)] flex flex-col justify-between pt-4" data-id="element-341">
      {/* Header */}
      <div className="flex items-center justify-between mb-4" data-id="element-342">
        <div className="flex items-center" data-id="element-343">
          <div className="w-10 h-10 bg-lavender/20 rounded-full flex items-center justify-center mr-3" data-id="element-344">
            <BookOpenIcon className="w-5 h-5 text-lavender" data-id="element-345" />
          </div>
          <h1 className="text-lg font-medium dark:text-white" data-id="element-346">
            Chat with COMO
          </h1>
        </div>
        <button onClick={() => setFontSize(size => {
        switch (size) {
          case 'normal':
            return 'large';
          case 'large':
            return 'x-large';
          default:
            return 'normal';
        }
      })} className="p-2 rounded-xl bg-gray-100 dark:bg-slate-700 
            text-gray-600 dark:text-gray-300" aria-label="Adjust text size" data-id="element-347">
          <Type className="w-5 h-5" data-id="element-348" />
        </button>
      </div>
      {/* Messages */}
      <div className="flex-1 flex flex-col justify-end mb-4" data-id="element-349">
        <div className="space-y-3" data-id="element-350">
          {recentMessages.map((message, index) => <MessageBubble key={index} message={message.text} isUser={message.isUser} fontSize={fontSize} data-id="element-351" />)}
        </div>
      </div>
      {/* Input */}
      <div className="bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm p-3 rounded-xl" data-id="element-352">
        <ChatInput onSend={handleSendMessage} onStartRecording={() => setIsListening(true)} onStopRecording={() => setIsListening(false)} isListening={isListening} suggestions={getSuggestions()} data-id="element-353" />
      </div>
    </div>;
};
export default Chat;